export default function addParamToURL(url, params) {
    const urlObj = new URL(url, window.location.toString());
    const paramsToAdd = Object.keys(params)
        .map(paramName => `${paramName}=${params[paramName]}`)
        .join('&');
    const newParams = urlObj.search ? `${urlObj.search}&${paramsToAdd}` : `?${paramsToAdd}`;
    urlObj.search = newParams;
    return urlObj.href;
}
//# sourceMappingURL=addParamToURL.js.map